// extracted by mini-css-extract-plugin
export default {"Container":"PagePlaceholder__Container__-YEaB","Title":"PagePlaceholder__Title__3x_UR","Text":"PagePlaceholder__Text__3Nrk0"};